/* ==============================================================================================
 * [ACCESS] PORTFOLIO DOWNLOADS TABLE
 * ============================================================================================== */

var Sushi, CGS, Icons;

(function (Sushi, CGS) {
	"use strict";

	var apiEndpoint = "/json/psd/portfolio.json";
	var tableElement = document.querySelector("#portfolioDownloadsTable");

	if (!tableElement) {
		return;
	}

	CGS.table(tableElement, {
		ajax: apiEndpoint,
		columns: [
			{
				data: "dateAndTime",
				className: "c-table__cell",
				searchable: true,
			},
			{
				data: null,
				orderable: false,
				className: "c-table__cell",
				width: "16px",
				defaultContent: "",
			},
		],
		columnDefs: [
			{
				targets: [ 1 ],
				render: function (data) {
					var link = document.createElement("a");

					link.classList.add("_db");
					link.href = data.filePath;
					link.target = "_blank";
					link.title = "Download " + data.fileName;
					link.innerHTML = Icons.fileXLS();

					return link.outerHTML;
				},
			},
		],
		initComplete: CGS.createRetractTableWrapper,
		dom: "<'top'>rt",
		scrollY: false,
	});

})(Sushi || (Sushi = {}), CGS || (CGS = {}), Icons || (Icons = {}));
